import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import { useMemo } from "react";
import {
  Container,
  Heading4,
  Icon,
  ImageLite,
  PageLink,
  Paragraph,
} from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { formatDate } from "shared/utils";

import styles from "./LayoutWidget082.module.scss";

export const LayoutWidget082 = ({ payload }) => {
  const { t } = useTranslation();
  const next_news = payload?.title ?? "";
  const instanceId = buildWidgetInstanceId(
    "l082",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { articles } = useCollectedData(instanceId, [
    { name: "articles", defaultValue: [] },
  ]);
  const [article] = articles;
  const { locale } = useRouter();

  const articleDate = useMemo(() => {
    return formatDate(article?.date, locale);
  }, [article?.date, locale]);

  if (articles.length === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Container>
        <PageLink directory="news" slug={article?.slug}>
          <div className={styles.block}>
            <ImageLite image={article?.previewImage} className={styles.image} />

            <div className={styles.content}>
              <Paragraph color="light" appearance="bigger">
                {t(next_news)}
              </Paragraph>
              <div className={styles.text}>
                <Paragraph className={styles.date} color="light">
                  {articleDate}
                </Paragraph>
                <div className={styles.title}>
                  <Heading4 color="light">{article.title}</Heading4>
                  <div className={styles.circle}>
                    <span className={styles.arrow}>
                      <Icon className={styles.icon} name="arrow_right" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </PageLink>
      </Container>
    </div>
  );
};

export default LayoutWidget082;
